import Cookies from 'js-cookie';
import actions from './actions';
import { DataService } from '../../config/dataService/dataService';

const { loginBegin, loginSuccess, loginErr, logoutBegin, logoutSuccess, logoutErr } = actions;

const login = (values, callback) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/auth/signin', values);
      console.log(response);
      if (response.status === 201) {
        Cookies.set('access_token', response.data.access_token);
        Cookies.set('userNationalId', response.data.payload.username);
        Cookies.set('userNationalId', response.data.payload.userNationalId);
        Cookies.set('logedIn', true);
        dispatch(loginSuccess(true));
        callback();
      } else {
        // Handle any non-201 status
        const errorMessage = response.data?.error?.message || 'Login failed';
        dispatch(loginErr(errorMessage));
      }
    } catch (err) {
      // Handle network or other errors
      const errorMessage = err.response?.data?.error?.message || 'Login failed';
      dispatch(loginErr(errorMessage));
    }
  };
};

const register = (values) => {
  return async (dispatch) => {
    dispatch(loginBegin());
    try {
      const response = await DataService.post('/auth/sign-up', values);
      if (response.data.errors) {
        dispatch(loginErr('Registration failed!'));
      } else {
        dispatch(loginSuccess(false));
      }
    } catch (err) {
      dispatch(loginErr(err));
    }
  };
};

const logOut = (callback) => {
  return async (dispatch) => {
    dispatch(logoutBegin());
    try {
      Cookies.remove('logedIn');
      Cookies.remove('access_token');
      dispatch(logoutSuccess(false));
      callback();
    } catch (err) {
      dispatch(logoutErr(err));
    }
  };
};

export { login, logOut, register };
